// actionTypes.js

export const FETCH_DATA_COMPANIES = 'FETCH_DATA_COMPANIES'
export const SET_DATA_COMPANIES = 'SET_DATA_COMPANIES'
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'
export const DELETE_COMPANY = 'DELETE_COMPANY'
export const SET_LICENCES = 'SET_LICENCES'